<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-06-07 10:51:41
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-09-08 18:15:59
-->
<template>
	<div class="pt-12">
		<Tip>
			<span slot="content" class="yx-color-text-primary font-h6-regular ml-10">
				<p>1.系统支持在官方提供的域名上进行二级域名配置，设置成功后十分钟左右生效，使用各自生成的二级域名访问PC管理后台可见自有品牌信息；</p>
				<p>2.域名每月最多修改3次，新域名生成后原域名将在次日失效且失效后其余团队可申请使用；</p>
				<div class="flex">
					<span>3.团队名称及logo应用场景为PC管理后台，详见</span>
					<a class="link yx-color-primary" href="https://chaoyongtuan.yuque.com/docs/share/48a1e8ff-d2bb-4731-a27b-a6decc05f528?#" target="_blank"
						>《团队资料配置(logo+名称)》</a
					>
				</div>
			</span>
			
		</Tip>
		<conf-block title="自定义二级域名配置" icon="conf-icon">
			<domain :config="config" @refresh="getTeamConf"></domain>
		</conf-block>
		<conf-block title="品牌信息" icon="admin-icon">
			<group-info :mode="mode" @cancel="cancel" :config="config" @refresh="getTeamConf"></group-info>
			<el-button type="primary" plain slot="extra" @click="editClick" v-if="!isEdit">编辑</el-button>
		</conf-block>
	</div>
</template>
<script>
import ConfBlock from './confBlock.vue';
import Domain from './domain.vue';
import GroupInfo from './groupInfo.vue';
import { getTeamConf } from '@/api/teamManage';
export default {
	data() {
		return {
			mode: 'show',
			config: {},
		};
	},
	computed: {
		isEdit() {
			return this.mode === 'edit';
		},
	},
	created() {
		this.getTeamConf();
	},
	methods: {
		async getTeamConf() {
			try {
				const data = await getTeamConf();
				this.config = data;
			} catch (error) {
				throw new Error(error);
			}
		},
		editClick() {
			this.mode = 'edit';
		},
		cancel() {
			this.mode = 'show';
		},
	},
	components: {
		ConfBlock,
		Domain,
		GroupInfo,
	},
};
</script>
